import { useTranslation } from 'react-i18next'

import { HTML_LINK_TARGET } from '../../constants/html'
import { BUTTON_HEIGHT_32 } from '../Button'
import { ButtonIconSelectControl, ButtonSelect } from '../Select'

import { getHelpButtonOptions } from './HelpButton.utils'

import * as styles from './HelpButton.module.css'

import FaqIcon from '../../icons/faq.svg'

function HelpButton() {
  const { t } = useTranslation()

  const faqOptions = getHelpButtonOptions()

  function handleSelectItem(item) {
    window.open(item.to, HTML_LINK_TARGET.blank)
  }

  return (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      className={styles.HelpButton}
      controlProps={{
        buttonProps: {
          beforeIconProps: {
            Icon: FaqIcon,
          },
          className: styles.iconButton,
          height: BUTTON_HEIGHT_32,
          isGrey: true,
          tooltip: t('Header.FaqLinkKey'),
        },
      }}
      dropdownFloatingConfig={{ maxWidthByRef: false }}
      listProps={{
        headerProps: {
          Search: null,
        },
      }}
      options={faqOptions}
      onSelectItem={handleSelectItem}
    />
  )
}

export default HelpButton
